import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { CATEGORY_IMAGES, HERO_IMAGE, STORE_IMAGE } from "@/data";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const SettingsContext = createContext(null);

export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("/api/")) return BACKEND + url;
  return url;
}

const FALLBACKS = {
  hero: HERO_IMAGE,
  store: STORE_IMAGE,
  cat_brautmode: CATEGORY_IMAGES.brautmode,
  cat_abendkleider: CATEGORY_IMAGES.abendkleider,
  cat_hennakleidung: CATEGORY_IMAGES.hennakleidung,
  cat_verlobungskleidung: CATEGORY_IMAGES.verlobungskleidung,
  cat_herrenanzuege: CATEGORY_IMAGES.herrenanzuege,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const load = useCallback(() => {
    api.get("/settings")
      .then((r) => setSettings(r.data))
      .catch(() => setSettings({ images: {}, opening_hours: {}, slot_interval: 60 }));
  }, []);

  useEffect(() => { load(); }, [load]);

  const img = useCallback((key) => {
    const images = (settings && settings.images) || {};
    return resolveImg(images[key]) || FALLBACKS[key] || "";
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, reload: load, img }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const c = useContext(SettingsContext);
  if (!c) throw new Error("useSettings must be used within SettingsProvider");
  return c;
}
